
function injectCommonHeader(containerId, breadcrumbTitle, basePath = '') {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Set default visibility based on previous state or default true initially
  // We will fetch real config shortly
  const initialDisplay = 'block'; // Or 'none' to avoid flash

  const headerHTML = `
    <header class="header header-sticky p-0 mb-0">
      <div class="container-fluid border-bottom px-4">
        <button class="header-toggler" type="button" onclick="const s=document.querySelector('#sidebar'); const p=document.getElementById('pageListPanel'); if(p && typeof togglePageListPanel==='function'){togglePageListPanel()} else if(s && window.coreui) coreui.Sidebar.getInstance(s).toggle();" style="margin-inline-start: -14px;">
          <svg class="icon icon-lg">
            <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-menu"></use>
          </svg>
        </button>
        <ul class="header-nav d-flex align-items-center" style="margin-left: 1rem;" id="headerNavLinks">
          <li class="nav-item">
            <a class="nav-link" href="${basePath}index.html">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-speedometer"></use>
              </svg> Dashboard
            </a>
          </li>
          <li class="nav-item" id="navItemAiAssistant" style="display:none;">
            <a class="nav-link" href="${basePath}ai">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-speech"></use>
              </svg> AI Asistan
            </a>
          </li>
          <li class="nav-item" id="navItemEvents" style="display:${initialDisplay};">
            <a class="nav-link" href="${basePath}admin/system-logs?tab=event">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-stream"></use>
              </svg> Events
            </a>
          </li>
          <li class="nav-item dropdown" id="navItemReports" style="display:none;">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-coreui-toggle="dropdown" aria-expanded="false">
              <svg class="icon icon-lg me-1">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-chart-line"></use>
              </svg> Raporlar
            </a>
            <ul class="dropdown-menu" id="reportsDropdownMenu">
              <li id="navItemChillerReport"><a class="dropdown-item" href="${basePath}Report/ChillerDailyReport">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-snow"></use></svg>Chiller Raporu
              </a></li>
              <li id="navItem5minReport"><a class="dropdown-item" href="${basePath}Report/5minReport">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-av-timer"></use></svg>5 Dakika Raporu
              </a></li>
              <li><hr class="dropdown-divider" id="reportsDropdownDivider" style="display:none;"></li>
              <!-- Generic reports injected here by fetchAndApplyMenuConfig -->
              <li><hr class="dropdown-divider" id="schedulerDropdownDivider" style="display:none;"></li>
              <li id="navItemReportScheduler" style="display:none;"><a class="dropdown-item" href="${basePath}admin/report-scheduler">
                <svg class="icon icon-sm me-2"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-clock"></use></svg>Rapor Zamanlayıcı
              </a></li>
            </ul>
          </li>
        </ul>
        <ul class="header-nav ms-auto">
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link" id="hubBellBtn" type="button" aria-expanded="false" aria-label="Aktif Alarmlar" title="Aktif Alarmlar" onclick="if(window.openActiveAlarmsModal) window.openActiveAlarmsModal()">
              <span class="nav-icon-wrapper" style="position: relative; display:inline-block;">
                <svg id="bellIconSvg" class="icon icon-lg">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-bell"></use>
                </svg>
                <span id="globalAlarmAttention" class="dr-alarm-attention" style="display:none;" aria-hidden="true">!</span>
                <span id="globalAlarmBadge" class="badge rounded-pill bg-danger" style="display:none; position:absolute; top:-4px; right:-8px; font-size:9px; padding:2px 5px; min-width:16px; line-height:1;">0</span>
              </span>
            </button>
          </li>
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link" id="hubDropdownBtn" type="button" data-coreui-toggle="dropdown" aria-expanded="false" title="NexBus hub status">
              <span class="nav-icon-wrapper" style="position: relative; display:inline-block;">
                <svg class="icon icon-lg">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-list-rich"></use>
                </svg>
                <span id="hubIndicatorDot" class="hub-indicator hub-disconnected" title="NexBus hub status" aria-hidden="true" style="pointer-events:none; position:absolute; top:2px; right:-6px; width:8px; height:8px; border-radius:50%; background:#6c757d; border:1px solid #fff;"></span>
              </span>
            </button>
            <ul id="hubConnectionDropdown" class="dropdown-menu dropdown-menu-start" style="min-width: 220px;">
              <li class="dropdown-item"><strong id="hubPopupStatus">Hub: disconnected</strong></li>
              <li class="dropdown-item d-flex justify-content-between align-items-center">
                <span id="hubPopupTags">Tags: 0</span>
                <button class="btn btn-sm btn-ghost-info ms-2 py-0 px-1" onclick="if(window.openHubDetailModal) window.openHubDetailModal()" title="İzle">
                  <svg class="icon"><use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-external-link"></use></svg>
                </button>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li class="dropdown-item small text-muted" id="hubPopupList">No tags subscribed</li>
            </ul>
          </li>
          <li class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <li class="nav-item dropdown">
            <button class="btn btn-link nav-link py-2 px-2 d-flex align-items-center" type="button" aria-expanded="false" data-coreui-toggle="dropdown">
              <svg class="icon icon-lg theme-icon-active">
                <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-contrast"></use>
              </svg>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" style="--cui-dropdown-min-width: 8rem;">
              <li>
                <button class="dropdown-item d-flex align-items-center" type="button" data-coreui-theme-value="light">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-sun"></use>
                  </svg>Light
                </button>
              </li>
              <li>
                <button class="dropdown-item d-flex align-items-center" type="button" data-coreui-theme-value="dark">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-moon"></use>
                  </svg>Dark
                </button>
              </li>
              <li>
                <button class="dropdown-item d-flex align-items-center active" type="button" data-coreui-theme-value="auto">
                  <svg class="icon icon-lg me-3">
                    <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-contrast"></use>
                  </svg>Auto
                </button>
              </li>
            </ul>
          </li>
          <li class="nav-item py-1">
            <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <li class="nav-item dropdown"><a class="nav-link py-0 pe-0" data-coreui-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
              <div class="avatar avatar-md"><img class="avatar-img" src="${basePath}assets/img/avatars/noname.jpg" alt="user@email.com"></div></a>
            <div class="dropdown-menu dropdown-menu-end pt-0">
              <div class="dropdown-header bg-body-tertiary text-body-secondary fw-semibold rounded-top mb-2">
                <div id="userDisplayName" class="fw-semibold">Loading...</div>
                <small id="userEmail" class="text-muted"></small>
              </div>
              <a class="dropdown-item" href="#" onclick="openChangePasswordModal(event)">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-lock-locked"></use>
                </svg> Şifre Değiştir
              </a>
              <a class="dropdown-item" href="${basePath}settings.html" id="settingsLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-settings"></use>
                </svg> Settings
              </a>
              <a class="dropdown-item" href="${basePath}admin/index.html" id="adminPanelLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-applications-settings"></use>
                </svg> Admin Panel
              </a>
              <a class="dropdown-item" href="${basePath}admin/nexbus-config.html" id="nexbusConfigLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-router"></use>
                </svg> NexBus Config
              </a>
              <a class="dropdown-item" href="${basePath}admin/report-scheduler" id="reportSchedulerLink" style="display: none;">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-clock"></use>
                </svg> Rapor Zamanlayıcı
              </a>
              <a class="dropdown-item" href="#" onclick="showDrInfo(event)">
                <svg class="icon me-2">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-info"></use>
                </svg> Dr Info
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" id="logoutBtn">
                <svg class="icon me-2 text-danger">
                  <use xlink:href="${basePath}vendors/@coreui/icons/svg/free.svg#cil-account-logout"></use>
                </svg> <span class="text-danger">Logout</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
      ${breadcrumbTitle ? `
      <div class="header-divider"></div>
      <div class="container-fluid">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb my-0 ms-2">
            <li class="breadcrumb-item"><a href="${basePath}index.html">Home</a></li>
            <li class="breadcrumb-item active"><span>${breadcrumbTitle}</span></li>
          </ol>
        </nav>
      </div>` : ''}
    </header>

    <!-- DR Info Modal -->
    <!-- Change Password Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true" style="z-index: 100000;">
      <div class="modal-dialog" style="z-index: 100001;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-lock me-2"></i>Şifre Değiştir</h5>
            <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Mevcut Şifre</label>
              <input type="password" class="form-control" id="currentPassword" placeholder="Mevcut şifrenizi girin">
            </div>
            <div class="mb-3">
              <label class="form-label">Yeni Şifre</label>
              <input type="password" class="form-control" id="newPassword" placeholder="Yeni şifrenizi girin">
            </div>
            <div class="mb-3">
              <label class="form-label">Yeni Şifre (Tekrar)</label>
              <input type="password" class="form-control" id="confirmNewPassword" placeholder="Yeni şifrenizi tekrar girin">
            </div>
            <div id="changePasswordError" class="alert alert-danger d-none"></div>
            <div id="changePasswordSuccess" class="alert alert-success d-none"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-coreui-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary" id="changePasswordBtn" onclick="submitChangePassword()">
              <i class="fas fa-save me-1"></i>Şifreyi Değiştir
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- DR Info Modal -->
    <div class="modal fade" id="drInfoModal" tabindex="-1" aria-hidden="true" style="z-index: 100000;">
      <div class="modal-dialog modal-lg" style="z-index: 100001;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-info-circle me-2"></i>DataRapor Info</h5>
            <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" id="drInfoModalBody">
            <ul class="nav nav-tabs mb-3" id="drInfoTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tab-company-btn" data-coreui-toggle="tab" data-coreui-target="#tab-company" type="button" role="tab"><i class="fas fa-building me-1"></i>Firma Bilgileri</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="tab-license-btn" data-coreui-toggle="tab" data-coreui-target="#tab-license" type="button" role="tab"><i class="fas fa-key me-1"></i>Lisans</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="tab-system-btn" data-coreui-toggle="tab" data-coreui-target="#tab-system" type="button" role="tab"><i class="fas fa-server me-1"></i>Sistem</button>
              </li>
            </ul>
            <div class="tab-content">
              <!-- FIRMA TAB -->
              <div class="tab-pane fade show active" id="tab-company" role="tabpanel">
                <div class="row g-3">
                  <div class="col-md-4 text-center">
                    <div id="companyLogoBox" style="width:100%;min-height:140px;border:2px dashed #6c757d;border-radius:8px;display:flex;align-items:center;justify-content:center;background:#f8f9fa;overflow:hidden;">
                      <span class="text-muted"><i class="fas fa-image fa-3x"></i></span>
                    </div>
                    <div class="mt-2 d-none" id="companyLogoControls">
                      <label class="btn btn-sm btn-outline-primary w-100">
                        <i class="fas fa-upload me-1"></i>Logo Yükle
                        <input type="file" id="companyLogoInput" accept="image/png,image/jpeg,image/svg+xml" hidden>
                      </label>
                      <button class="btn btn-sm btn-outline-danger w-100 mt-1" onclick="removeCompanyLogo()"><i class="fas fa-trash me-1"></i>Kaldır</button>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="mb-2"><label class="form-label mb-0 small text-muted">Firma Adı</label><input class="form-control form-control-sm company-field" data-field="companyName" placeholder="Firma Adı"></div>
                    <div class="mb-2"><label class="form-label mb-0 small text-muted">Adres</label><textarea class="form-control form-control-sm company-field" data-field="address" rows="2" placeholder="Adres"></textarea></div>
                    <div class="row g-2">
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Telefon</label><input class="form-control form-control-sm company-field" data-field="phone" placeholder="+90..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">E-posta</label><input class="form-control form-control-sm company-field" data-field="email" placeholder="info@..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Web Sitesi</label><input class="form-control form-control-sm company-field" data-field="website" placeholder="https://..."></div>
                      <div class="col-md-6 mb-2"><label class="form-label mb-0 small text-muted">Vergi No</label><input class="form-control form-control-sm company-field" data-field="taxNumber" placeholder="Vergi Numarası"></div>
                    </div>
                    <div id="companyEditHint" class="small text-muted d-none"><i class="fas fa-info-circle"></i> Düzenleme yetkisi admin kullanıcılarla sınırlıdır.</div>
                  </div>
                </div>
              </div>
              <!-- LISANS TAB -->
              <div class="tab-pane fade" id="tab-license" role="tabpanel">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr><th style="width:200px;">Durum</th><td id="drInfoLicenseStatus">-</td></tr>
                      <tr><th>Müşteri</th><td id="drInfoLicenseCustomer">-</td></tr>
                      <tr><th>Geçerlilik Sonu</th><td id="drInfoLicenseExpiry">-</td></tr>
                      <tr><th>Kalan Gün</th><td id="drInfoLicenseDays">-</td></tr>
                      <tr><th>Instance</th><td id="drInfoLicenseInstance">-</td></tr>
                      <tr><th>Fingerprint</th><td id="drInfoLicenseFingerprint" style="font-family:monospace;font-size:11px;word-break:break-all;">-</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- SISTEM TAB -->
              <div class="tab-pane fade" id="tab-system" role="tabpanel">
                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr><th style="width:200px;">Uygulama Versiyonu</th><td id="drInfoVersion">-</td></tr>
                      <tr><th>Backend Versiyonu</th><td id="drInfoBackendVersion">-</td></tr>
                      <tr><th>Instance</th><td id="drInfoInstance">-</td></tr>
                      <tr><th>Backend URL</th><td id="drInfoBackend">-</td></tr>
                      <tr><th>Ortam</th><td id="drInfoEnv">-</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-success me-auto" id="drInfoPdfBtn" onclick="exportDrInfoPdf()"><i class="fas fa-file-pdf me-1"></i>PDF Çıktısı</button>
            <button type="button" class="btn btn-primary d-none" id="drInfoSaveBtn" onclick="saveCompanyInfo()"><i class="fas fa-save me-1"></i>Kaydet</button>
            <button type="button" class="btn btn-secondary" data-coreui-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>
  `;

  container.innerHTML = headerHTML;

  // Fix: Z-Index/Backdrop issue
  // Move the modal to the body immediately after injection
  // This prevents it from being trapped in stacked contexts (like sticky headers)
  const infoModal = document.getElementById('drInfoModal');
  if (infoModal && document.body) {
      document.body.appendChild(infoModal);
  }

  setReportMenuVisibility(false);
  fetchAndApplyMenuConfig();

  // Initialize User Info
  if (window.Auth) {
    const userInfo = window.Auth.getUserInfo();
    if (userInfo) {
      const displayNameEl = document.getElementById('userDisplayName');
      const emailEl = document.getElementById('userEmail');
      const settingsLink = document.getElementById('settingsLink');
      const adminPanelLink = document.getElementById('adminPanelLink');
      const nexbusConfigLink = document.getElementById('nexbusConfigLink');
      const reportSchedulerLink = document.getElementById('reportSchedulerLink');
      
      if (displayNameEl) displayNameEl.textContent = userInfo.name || userInfo.username || userInfo.UserName || userInfo.FirstName || 'User';
      if (emailEl) emailEl.textContent = userInfo.email || userInfo.Email || '';
      
      // Rol bazlı menü kontrolü
      // Role: 'user' (standart), 'admin' (yönetici), 'super_admin' (tam yetki)
      const userRole = (userInfo.Role || userInfo.role || 'user').toLowerCase();
      const showAdmin = typeof window.Auth.hasRole === 'function'
        ? window.Auth.hasRole('admin', userInfo)
        : userRole === 'admin' || userRole === 'super_admin';
      const showSuperAdmin = typeof window.Auth.hasRole === 'function'
        ? window.Auth.hasRole('super_admin', userInfo)
        : userRole === 'super_admin';
      
      // Settings: admin ve üzeri
      if (settingsLink) settingsLink.style.display = showAdmin ? 'block' : 'none';
      // Admin Panel: admin ve üzeri
      if (adminPanelLink) adminPanelLink.style.display = showAdmin ? 'block' : 'none';
      // NexBus Config: sadece super_admin
      if (nexbusConfigLink) nexbusConfigLink.style.display = showSuperAdmin ? 'block' : 'none';
      // Rapor Zamanlayıcı: admin ve üzeri
      if (reportSchedulerLink) reportSchedulerLink.style.display = showAdmin ? 'block' : 'none';
    }
  }

  // Initialize Logout
  const logoutBtn = document.getElementById('logoutBtn');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.Auth && typeof window.Auth.logout === 'function') {
        window.Auth.logout();
      }
    });
  }
}

// ─── Şifre Değiştir ───
function openChangePasswordModal(e) {
    if(e) e.preventDefault();
    // Reset fields
    document.getElementById('currentPassword').value = '';
    document.getElementById('newPassword').value = '';
    document.getElementById('confirmNewPassword').value = '';
    document.getElementById('changePasswordError').classList.add('d-none');
    document.getElementById('changePasswordSuccess').classList.add('d-none');
    document.getElementById('changePasswordBtn').disabled = false;
    
    const modalEl = document.getElementById('changePasswordModal');
    if (modalEl && window.coreui) {
        if (modalEl.parentElement !== document.body || document.body.lastElementChild !== modalEl) {
            document.body.appendChild(modalEl);
        }
        const modal = new coreui.Modal(modalEl, { backdrop: true });
        modal.show();
    }
}

async function submitChangePassword() {
    const errorEl = document.getElementById('changePasswordError');
    const successEl = document.getElementById('changePasswordSuccess');
    const btn = document.getElementById('changePasswordBtn');
    
    errorEl.classList.add('d-none');
    successEl.classList.add('d-none');
    
    const currentPassword = document.getElementById('currentPassword').value.trim();
    const newPassword = document.getElementById('newPassword').value.trim();
    const confirmNewPassword = document.getElementById('confirmNewPassword').value.trim();
    
    if (!currentPassword || !newPassword || !confirmNewPassword) {
        errorEl.textContent = 'Tüm alanları doldurun.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    if (newPassword !== confirmNewPassword) {
        errorEl.textContent = 'Yeni şifreler eşleşmiyor.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    if (newPassword.length < 12 || newPassword.length > 128) {
        errorEl.textContent = 'Yeni şifre 12-128 karakter arasında olmalıdır.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    // Kullanıcı bilgisi
    const userInfo = window.Auth ? window.Auth.getUserInfo() : null;
    if (!userInfo || !userInfo.UserName) {
        errorEl.textContent = 'Kullanıcı bilgisi alınamadı. Lütfen tekrar giriş yapın.';
        errorEl.classList.remove('d-none');
        return;
    }
    
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Kaydediliyor...';
    
    try {
        const resp = await fetch('/api/v1/users/change-password', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${window.Auth.getToken()}`
            },
            body: JSON.stringify({
                username: userInfo.UserName,
                current_password: currentPassword,
                new_password: newPassword
            })
        });
        
        const data = await resp.json();
        
        if (!resp.ok) {
            throw new Error(data.error || 'Şifre değiştirme başarısız.');
        }
        
        successEl.textContent = 'Şifre başarıyla değiştirildi!';
        successEl.classList.remove('d-none');
        
        // 2 saniye sonra modalı kapat
        setTimeout(() => {
            const modalEl = document.getElementById('changePasswordModal');
            const modal = coreui.Modal.getInstance(modalEl);
            if (modal) modal.hide();
        }, 2000);
        
    } catch (err) {
        errorEl.textContent = err.message;
        errorEl.classList.remove('d-none');
    } finally {
        btn.disabled = false;
        btn.innerHTML = '<i class="fas fa-save me-1"></i>Şifreyi Değiştir';
    }
}

async function showDrInfo(e) {
    if(e) e.preventDefault();
    
    // Show Modal immediately
    const modalEl = document.getElementById('drInfoModal');
    if (modalEl && window.coreui) {
        
        // Final Safety: Ensure it is the last child of body every time we open it
        // This defeats any subsequent stacking contexts created by other libs
        if (modalEl.parentElement !== document.body || document.body.lastElementChild !== modalEl) {
             document.body.appendChild(modalEl);
        }

        const modal = window.coreui.Modal.getInstance(modalEl) || new window.coreui.Modal(modalEl);
        
        // Manual fix for "Tamam" button click if data-attribute fails
        const dismissBtns = modalEl.querySelectorAll('[data-coreui-dismiss="modal"]');
        dismissBtns.forEach(btn => {
            btn.onclick = () => modal.hide();
        });

        modal.show();
    } else {
        console.error('Modal element or CoreUI not found');
        return;
    }

    // Yetki kontrolu — admin/super_admin firma bilgilerini duzenleyebilir
    let canEdit = false;
    try {
        if (window.Auth && typeof window.Auth.getUserInfo === 'function') {
            const u = window.Auth.getUserInfo() || {};
            const role = String(u.Role || u.role || '').toLowerCase();
            canEdit = typeof window.Auth.hasRole === 'function'
              ? window.Auth.hasRole('admin', u)
              : role === 'admin' || role === 'super_admin';
        }
    } catch {}
    const saveBtn = document.getElementById('drInfoSaveBtn');
    const logoCtl = document.getElementById('companyLogoControls');
    const editHint = document.getElementById('companyEditHint');
    if (saveBtn) saveBtn.classList.toggle('d-none', !canEdit);
    if (logoCtl) logoCtl.classList.toggle('d-none', !canEdit);
    if (editHint) editHint.classList.toggle('d-none', canEdit);
    document.querySelectorAll('.company-field').forEach(el => {
        el.disabled = !canEdit;
        el.readOnly = !canEdit;
    });

    // Firma bilgilerini yukle
    loadCompanyInfo();

    // Logo input listener
    const logoInput = document.getElementById('companyLogoInput');
    if (logoInput && !logoInput.dataset.bound) {
        logoInput.addEventListener('change', handleCompanyLogoSelect);
        logoInput.dataset.bound = '1';
    }

    // Try to find API_BASE if defined globally, otherwise guess
    const apiBase = (typeof API_BASE !== 'undefined') ? API_BASE : '/admin/api/nexbus';
    
    const backendEl = document.getElementById('drInfoBackend');
    const envEl = document.getElementById('drInfoEnv');
    const versionEl = document.getElementById('drInfoVersion');
    const backendVersionEl = document.getElementById('drInfoBackendVersion');
    const instanceEl = document.getElementById('drInfoInstance');
    const licStatusEl = document.getElementById('drInfoLicenseStatus');
    const licCustEl = document.getElementById('drInfoLicenseCustomer');
    const licExpEl = document.getElementById('drInfoLicenseExpiry');
    const licDaysEl = document.getElementById('drInfoLicenseDays');
    const licInstEl = document.getElementById('drInfoLicenseInstance');
    const licFpEl = document.getElementById('drInfoLicenseFingerprint');

    if(backendEl) backendEl.textContent = 'Yükleniyor...';
    if(envEl) envEl.textContent = 'Yükleniyor...';
    if(versionEl) versionEl.textContent = 'Yükleniyor...';
    if(backendVersionEl) backendVersionEl.textContent = 'Yükleniyor...';
    if(instanceEl) instanceEl.textContent = 'Yükleniyor...';

    try {
        const response = await fetch(`${apiBase}/info`);
        if (response.ok) {
            const data = await response.json();
            if(backendEl) backendEl.textContent = data.baseUrl || '-';
            if(envEl) envEl.textContent = data.env || '-';
            if(versionEl) versionEl.textContent = data.version || '-';
            if(backendVersionEl) backendVersionEl.textContent = data.backendVersion || '-';
            if(instanceEl) instanceEl.textContent = data.instanceName || 'default';
        }
    } catch (err) {
        console.warn('Could not fetch backend info:', err);
        if(backendEl) backendEl.textContent = 'Bilgi alinamadi';
        if(envEl) envEl.textContent = '-';
        if(backendVersionEl) backendVersionEl.textContent = 'Bilgi alınamadı';
    }

    // Lisans bilgisi — detayli
    try {
        const licResp = await fetch('/api/license/status');
        const licData = await licResp.json();
        window.__drInfoLicenseData = licData;
        if (licStatusEl) {
            if (licData.status === 'valid') {
                licStatusEl.innerHTML = '<span class="badge bg-success">✅ Geçerli</span>';
            } else {
                licStatusEl.innerHTML = '<span class="badge bg-danger">❌ ' + (licData.message || 'Geçersiz') + '</span>';
            }
        }
        const lic = licData.license || {};
        if (licCustEl) licCustEl.textContent = lic.customerName || '-';
        if (licExpEl) licExpEl.textContent = lic.expiryDate || 'Süresiz';
        if (licDaysEl) {
            if (lic.expiryDate) {
                const d = Math.ceil((new Date(lic.expiryDate) - new Date()) / (1000*60*60*24));
                const color = d <= 0 ? 'text-danger' : d <= 30 ? 'text-warning' : 'text-success';
                licDaysEl.innerHTML = '<span class="' + color + '"><strong>' + d + '</strong> gün</span>';
            } else {
                licDaysEl.textContent = '-';
            }
        }
        if (licInstEl) licInstEl.textContent = lic.instanceName || licData.instanceName || '-';
        if (licFpEl) licFpEl.textContent = licData.fingerprint || '-';
        if (versionEl && licData.version && versionEl.textContent === 'Yükleniyor...') versionEl.textContent = licData.version;
    } catch {
        if (licStatusEl) licStatusEl.textContent = 'Bilgi alınamadı';
    }
}

// Firma bilgilerini yukle
async function loadCompanyInfo() {
    try {
        const resp = await fetch('/api/ui-settings/company');
        const data = await resp.json();
        window.__drInfoCompany = data;
        document.querySelectorAll('.company-field').forEach(el => {
            const k = el.dataset.field;
            el.value = data[k] || '';
        });
        renderCompanyLogo(data.logo);
    } catch (err) {
        console.warn('Firma bilgileri yuklenemedi:', err);
    }
}

function renderCompanyLogo(dataUrl) {
    const box = document.getElementById('companyLogoBox');
    if (!box) return;
    if (dataUrl) {
        box.innerHTML = '<img src="' + dataUrl + '" style="max-width:100%;max-height:140px;object-fit:contain;" alt="Logo">';
    } else {
        box.innerHTML = '<span class="text-muted"><i class="fas fa-image fa-3x"></i><div class="small mt-2">Logo yok</div></span>';
    }
}

function handleCompanyLogoSelect(e) {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) {
        alert('Logo 2MB\'dan kucuk olmali');
        e.target.value = '';
        return;
    }
    const reader = new FileReader();
    reader.onload = (ev) => {
        window.__drInfoPendingLogo = ev.target.result;
        renderCompanyLogo(ev.target.result);
    };
    reader.readAsDataURL(file);
}

function removeCompanyLogo() {
    window.__drInfoPendingLogo = '';
    renderCompanyLogo('');
}

async function saveCompanyInfo() {
    const payload = {};
    document.querySelectorAll('.company-field').forEach(el => {
        payload[el.dataset.field] = el.value || '';
    });
    if (window.__drInfoPendingLogo !== undefined) {
        payload.logo = window.__drInfoPendingLogo;
    } else if (window.__drInfoCompany) {
        payload.logo = window.__drInfoCompany.logo || '';
    }
    const btn = document.getElementById('drInfoSaveBtn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i>Kaydediliyor...'; }
    try {
        const resp = await fetch('/api/ui-settings/company', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        window.__drInfoCompany = await resp.json();
        window.__drInfoPendingLogo = undefined;
        if (btn) { btn.innerHTML = '<i class="fas fa-check me-1"></i>Kaydedildi'; setTimeout(() => { btn.innerHTML = '<i class="fas fa-save me-1"></i>Kaydet'; btn.disabled = false; }, 1500); }
    } catch (err) {
        alert('Kaydedilemedi: ' + err.message);
        if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fas fa-save me-1"></i>Kaydet'; }
    }
}

async function ensureTurkishFont(doc) {
    // Roboto fontu Türkçe karakterleri (ç, ş, ğ, ı, ö, ü, İ) destekler
    try {
        if (!window.__drInfoFontB64) {
            const urls = {
                reg: 'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Regular.ttf',
                bold: 'https://cdn.jsdelivr.net/gh/googlefonts/roboto@main/src/hinted/Roboto-Bold.ttf'
            };
            const toB64 = async (url) => {
                const r = await fetch(url);
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const buf = await r.arrayBuffer();
                const bytes = new Uint8Array(buf);
                let bin = '';
                const chunk = 0x8000;
                for (let i = 0; i < bytes.length; i += chunk) {
                    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
                }
                return btoa(bin);
            };
            const [reg, bold] = await Promise.all([toB64(urls.reg), toB64(urls.bold)]);
            window.__drInfoFontB64 = { reg, bold };
        }
        doc.addFileToVFS('Roboto-Regular.ttf', window.__drInfoFontB64.reg);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.addFileToVFS('Roboto-Bold.ttf', window.__drInfoFontB64.bold);
        doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
        doc.setFont('Roboto', 'normal');
        return 'Roboto';
    } catch (e) {
        try { console.warn('Turkce font yuklenemedi, helvetica kullanilacak:', e); } catch {}
        return 'helvetica';
    }
}

async function exportDrInfoPdf() {
    if (!window.jspdf || !window.jspdf.jsPDF) {
        // jsPDF CDN'den yukle
        await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    if (!window.jspdf.autoTable) {
        await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.31/jspdf.plugin.autotable.min.js';
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    // Türkçe karakter destekli font yükle
    const fontName = await ensureTurkishFont(doc);
    const company = window.__drInfoCompany || {};
    const lic = window.__drInfoLicenseData || {};
    const licObj = lic.license || {};

    // Logo (varsa sol üstte göster)
    let y = 15;
    let hasLogo = false;
    if (company.logo) {
        try {
            const fmt = (company.logo.match(/^data:image\/(\w+);/) || [])[1] || 'PNG';
            const upFmt = fmt.toUpperCase() === 'JPG' ? 'JPEG' : fmt.toUpperCase();
            doc.addImage(company.logo, upFmt, 15, 10, 30, 30);
            hasLogo = true;
        } catch (e) { try { console.warn('Logo PDF embed hatasi:', e); } catch {} }
    }

    // Başlık — logo varsa sağa kaydır, yoksa ortala
    doc.setFontSize(18);
    doc.setTextColor(50, 31, 219);
    doc.setFont(fontName, 'bold');
    const titleX = hasLogo ? 115 : 105;
    const titleAlign = hasLogo ? 'center' : 'center';
    doc.text('DataRapor Lisans Bilgileri', titleX, 20, { align: titleAlign });
    doc.setFontSize(10);
    doc.setFont(fontName, 'normal');
    doc.setTextColor(100);
    doc.text('Tarih: ' + new Date().toLocaleString('tr-TR'), titleX, 28, { align: titleAlign });
    doc.setTextColor(0);

    // Ortak autoTable stil ayarlari — Türkçe font, satir kaydirma, genis deger sutunu
    const commonTable = {
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 2, overflow: 'linebreak', font: fontName, valign: 'middle' },
        headStyles: { fillColor: [50, 31, 219], textColor: 255, font: fontName, fontStyle: 'bold' },
        columnStyles: { 0: { cellWidth: 40, fontStyle: 'bold' }, 1: { cellWidth: 140 } },
        margin: { left: 15, right: 15 }
    };

    y = 50;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Firma Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Firma Adı', company.companyName || '-'],
            ['Adres', company.address || '-'],
            ['Telefon', company.phone || '-'],
            ['E-posta', company.email || '-'],
            ['Web Sitesi', company.website || '-'],
            ['Vergi No', company.taxNumber || '-']
        ]
    }));

    y = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Lisans Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    let daysLeft = '-';
    if (licObj.expiryDate) {
        const d = Math.ceil((new Date(licObj.expiryDate) - new Date()) / (1000*60*60*24));
        daysLeft = d + ' gün';
    }
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Durum', lic.status === 'valid' ? 'Geçerli' : (lic.message || 'Geçersiz')],
            ['Müşteri', licObj.customerName || '-'],
            ['Geçerlilik Sonu', licObj.expiryDate || 'Süresiz'],
            ['Kalan Gün', daysLeft],
            ['Instance', licObj.instanceName || lic.instanceName || '-'],
            ['Fingerprint', lic.fingerprint || '-']
        ]
    }));

    y = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(13);
    doc.setFont(fontName, 'bold');
    doc.setTextColor(50, 31, 219);
    doc.text('Sistem Bilgileri', 15, y);
    doc.setTextColor(0);
    y += 4;
    doc.autoTable(Object.assign({}, commonTable, {
        startY: y,
        head: [['Alan', 'Değer']],
        body: [
            ['Versiyon', (document.getElementById('drInfoVersion')||{}).textContent || '-'],
            ['Backend Versiyonu', (document.getElementById('drInfoBackendVersion')||{}).textContent || '-'],
            ['Instance', (document.getElementById('drInfoInstance')||{}).textContent || '-'],
            ['Backend URL', (document.getElementById('drInfoBackend')||{}).textContent || '-'],
            ['Ortam', (document.getElementById('drInfoEnv')||{}).textContent || '-']
        ]
    }));

    // Footer: Geliştirici firma bilgileri (her sayfada)
    const pageCount = doc.internal.getNumberOfPages();
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        // Ayirici çizgi
        doc.setDrawColor(50, 31, 219);
        doc.setLineWidth(0.4);
        doc.line(15, pageH - 20, pageW - 15, pageH - 20);
        // Gelistirici etiketi
        doc.setFontSize(8);
        doc.setFont(fontName, 'bold');
        doc.setTextColor(50, 31, 219);
        doc.text('Geliştirici Firma', 15, pageH - 15);
        // Firma adi ve adres
        doc.setFont(fontName, 'normal');
        doc.setTextColor(80);
        doc.setFontSize(8);
        doc.text('ZAKE Mühendislik Çevre Tek. ve Tek. Emn. Sis. San. ve Tic. Ltd. Şti.', 15, pageH - 10);
        doc.text('Uzayçağı Cad. No:62/4 OSTİM / ANKARA', 15, pageH - 6);
        // Sayfa numarasi
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text('Sayfa ' + i + ' / ' + pageCount, pageW - 15, pageH - 6, { align: 'right' });
    }

    doc.save('DataRapor-Info-' + new Date().toISOString().slice(0,10) + '.pdf');
}

/**
 * Fetches UI configuration and toggles menu items (Header & Sidebar)
 * Also loads generic report list into the Reports dropdown
 */
async function fetchAndApplyMenuConfig() {
  try {
    const response = await fetch('/api/ui-settings/menu');
    if (!response.ok) return;
    const config = await response.json();

    const aiItem = document.getElementById('navItemAiAssistant');
    if (aiItem) {
      // Varsayılan kapalıdır. Menü yalnız sunucu bu kullanıcı, erişim modu,
      // API anahtarı ve AI_MODEL için birlikte hazır olduğunu doğrularsa açılır.
      aiItem.style.display = 'none';
      try {
        const aiResponse = await fetch('/api/ai/status');
        if (aiResponse.ok) {
          const aiStatus = await aiResponse.json();
          aiItem.style.display = aiStatus.environment_enabled === true && aiStatus.available === true ? '' : 'none';
        }
      } catch (error) {
        console.warn('AI menu status could not be loaded:', error);
      }
    }

    // 1. Toggle Header Item
    const showEvents = config.showEvents !== false;
    const headerEventsItem = document.getElementById('navItemEvents');
    if (headerEventsItem) {
      headerEventsItem.style.display = showEvents ? '' : 'none';
    }

    // Genel ayar açık olsa bile yetkili raporlar yüklenene kadar menüyü gizle.
    setReportMenuVisibility(false);

    // 1b. Toggle individual report links (Chiller, 5min)
    const modules = (config.modules && config.modules.reports) || {};
    const chillerItem = document.getElementById('navItemChillerReport');
    if (chillerItem) chillerItem.style.display = (modules.chiller !== false) ? '' : 'none';
    const fiveMinItem = document.getElementById('navItem5minReport');
    if (fiveMinItem) fiveMinItem.style.display = (modules.fiveMin !== false) ? '' : 'none';

    // 2. Backend yalnızca giriş yapan kullanıcının yetkili raporlarını döndürür.
    if (config.showReports) {
      const reports = await loadGenericReportsDropdown();
      setReportMenuVisibility(reports.length > 0);
    }

  } catch (e) {
    console.warn('Error applying menu config:', e);
  }
}

function setReportMenuVisibility(visible) {
  const headerReportItem = document.getElementById('navItemReports');
  if (headerReportItem) headerReportItem.style.display = visible ? '' : 'none';

  const sidebarLinks = document.querySelectorAll('.sidebar .nav-link, .sidebar-nav .nav-link');
  sidebarLinks.forEach(link => {
    const href = link.getAttribute('href') || '';
    if (link.textContent.trim().includes('Raporlar') || href.includes('Report')) {
      const parentItem = link.closest('.nav-item');
      if (parentItem) parentItem.style.display = visible ? '' : 'none';
    }
  });
}

/**
 * Loads generic report configs and adds them to the Reports dropdown menu
 */
async function loadGenericReportsDropdown() {
  try {
    const res = await fetch('/api/v1/report/configs');
    if (!res.ok) return [];
    const json = await res.json();
    const reports = json.data || [];

    const menu = document.getElementById('reportsDropdownMenu');
    const divider = document.getElementById('reportsDropdownDivider');
    if (!menu) return reports;

    // Yeniden yüklemede dinamik rapor bağlantılarını çoğaltma.
    menu.querySelectorAll('[data-generic-report-item]').forEach(item => item.remove());
    if (divider) divider.style.display = reports.length > 0 ? '' : 'none';

    const userInfo = window.Auth && typeof window.Auth.getUserInfo === 'function'
      ? (window.Auth.getUserInfo() || {})
      : {};
    const role = String(userInfo.Role || userInfo.role || '').toLowerCase();
    const isAdmin = window.Auth && typeof window.Auth.hasRole === 'function'
      ? window.Auth.hasRole('admin', userInfo)
      : role === 'admin' || role === 'super_admin';
    const schedulerDivider = document.getElementById('schedulerDropdownDivider');
    const schedulerItem = document.getElementById('navItemReportScheduler');
    if (schedulerDivider) schedulerDivider.style.display = isAdmin ? '' : 'none';
    if (schedulerItem) schedulerItem.style.display = isAdmin ? '' : 'none';

    if (reports.length === 0) return [];

    // Add generic reports
    reports.forEach(r => {
      const li = document.createElement('li');
      li.dataset.genericReportItem = 'true';
      const iconName = r.icon || 'cil-chart';
      li.innerHTML = `<a class="dropdown-item" href="/Report/GenericReport?report=${encodeURIComponent(r.id)}">
        <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#${iconName}"></use></svg>${r.title}
      </a>`;
      menu.appendChild(li);
    });

    // Add "Tüm Raporlar" link at the end
    const allLi = document.createElement('li');
    allLi.dataset.genericReportItem = 'true';
    allLi.innerHTML = '<hr class="dropdown-divider">';
    menu.appendChild(allLi);
    const viewAllLi = document.createElement('li');
    viewAllLi.dataset.genericReportItem = 'true';
    viewAllLi.innerHTML = `<a class="dropdown-item text-primary fw-semibold" href="/Report/GenericReport">
      <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-list-rich"></use></svg>Tüm Raporlar
    </a>`;
    menu.appendChild(viewAllLi);

    // Add "Rapor Tasarımcısı" link (admin only)
    if (isAdmin) {
      const designerLi = document.createElement('li');
      designerLi.dataset.genericReportItem = 'true';
      designerLi.innerHTML = `<a class="dropdown-item text-warning" href="/admin/report-designer">
        <svg class="icon icon-sm me-2"><use xlink:href="vendors/@coreui/icons/svg/free.svg#cil-pencil"></use></svg>Rapor Tasarımcısı
      </a>`;
      menu.appendChild(designerLi);
    }
    return reports;
  } catch (e) {
    console.warn('Error loading generic reports dropdown:', e);
    return [];
  }
}

// ─── VERSION CHECK — Güncelleme bildirimi (tüm sayfalarda) ──────────
(function initVersionCheck() {
  let currentVersion = null;
  const CHECK_INTERVAL = 30000; // 30 saniyede bir kontrol

  async function checkVersion() {
    try {
      const res = await fetch('/admin/api/nexbus/info');
      if (!res.ok) return;
      const data = await res.json();
      const serverVersion = data.version;
      if (!serverVersion) return;
      if (currentVersion === null) {
        currentVersion = serverVersion;
        return;
      }
      if (serverVersion !== currentVersion) {
        showUpdateToast(serverVersion);
        currentVersion = serverVersion;
      }
    } catch (e) { /* sessizce yut */ }
  }

  function showUpdateToast(newVersion) {
    if (document.getElementById('versionUpdateToast')) return;
    const toast = document.createElement('div');
    toast.id = 'versionUpdateToast';
    toast.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:999999;background:#1e293b;color:#fff;border:1px solid #3b82f6;border-radius:8px;padding:14px 20px;box-shadow:0 8px 32px rgba(0,0,0,0.4);display:flex;align-items:center;gap:12px;font-size:14px;max-width:500px;animation:slideDown .3s ease;';
    toast.innerHTML = '<i class="fas fa-arrow-circle-up" style="color:#3b82f6;font-size:20px;"></i>' +
      '<div style="flex:1;"><b>Güncelleme mevcut!</b><br><small style="color:#94a3b8;">Yeni sürüm: v' + newVersion + '</small></div>' +
      '<button onclick="location.reload()" style="background:#3b82f6;color:#fff;border:none;border-radius:6px;padding:8px 16px;cursor:pointer;font-size:13px;white-space:nowrap;">Yenile</button>' +
      '<button onclick="this.parentElement.remove()" style="background:none;border:none;color:#64748b;cursor:pointer;font-size:18px;padding:0 4px;">✕</button>';
    document.body.appendChild(toast);
    if (!document.getElementById('versionToastStyle')) {
      const style = document.createElement('style');
      style.id = 'versionToastStyle';
      style.textContent = '@keyframes slideDown{from{opacity:0;transform:translateX(-50%) translateY(-20px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}';
      document.head.appendChild(style);
    }
  }

  setTimeout(checkVersion, 5000);
  setInterval(checkVersion, CHECK_INTERVAL);
})();
// ─── /VERSION CHECK ────────────────────────────────────────

// ─── GLOBAL ACTIVE ALARMS (header bell) ────────────────────
(function () {
  if (window.__drGlobalAlarms) return; // tek sefer
  const ST = window.__drGlobalAlarms = {
    alerts: [],
    timer: null,
    modalEl: null,
    msgMap: {},
    configMap: {},
    msgFetchedAt: 0,
    alarmSnapshotReady: false,
    soundSettings: null,
    sound: {
      context: null,
      loopTimer: null,
      stopTimer: null,
      playing: false,
      currentKeys: new Set(),
      previousKeys: new Set(),
      silencedKeys: new Set()
    }
  };
  const REFRESH_MS = 5000;
  const MSG_TTL_MS = 60000; // config mesajları 1 dk cache
  const SOUND_DEFAULTS = Object.freeze({ enabled: false, mode: 'duration', soundType: 'standard', durationSeconds: 10, volume: 0.35 });
  const SOUND_TYPE_LABELS = Object.freeze({
    standard: 'Standart Darbe',
    double: 'Çift Uyarı',
    ascending: 'Yükselen Ton',
    siren: 'Siren'
  });

  function getSoundStorageKey() {
    let subject = 'anonymous';
    try {
      const user = typeof getUserInfo === 'function'
        ? getUserInfo()
        : JSON.parse(localStorage.getItem('user_info') || 'null');
      subject = user && (user.UserId || user.user_id || user.UserName || user.username) || subject;
    } catch (e) { /* varsayılan kullanıcı anahtarını kullan */ }
    return `dr-alarm-sound:v1:${encodeURIComponent(String(subject))}`;
  }

  function normalizeSoundSettings(raw) {
    const input = raw && typeof raw === 'object' ? raw : {};
    const duration = Number(input.durationSeconds);
    const volume = Number(input.volume);
    return {
      enabled: input.enabled === true,
      mode: input.mode === 'until-ack' ? 'until-ack' : 'duration',
      soundType: Object.prototype.hasOwnProperty.call(SOUND_TYPE_LABELS, input.soundType) ? input.soundType : SOUND_DEFAULTS.soundType,
      durationSeconds: [5, 10, 15, 30, 60].includes(duration) ? duration : SOUND_DEFAULTS.durationSeconds,
      volume: Number.isFinite(volume) ? Math.min(0.8, Math.max(0.05, volume)) : SOUND_DEFAULTS.volume
    };
  }

  function loadSoundSettings() {
    try { return normalizeSoundSettings(JSON.parse(localStorage.getItem(getSoundStorageKey()) || 'null')); }
    catch (e) { return { ...SOUND_DEFAULTS }; }
  }

  function saveSoundSettings(next) {
    ST.soundSettings = normalizeSoundSettings(next);
    try { localStorage.setItem(getSoundStorageKey(), JSON.stringify(ST.soundSettings)); } catch (e) { /* depolama kapalı olabilir */ }
    updateSoundUi();
    if (!ST.soundSettings.enabled) stopAlarmSound();
    else processAlarmSound(ST.alerts, true);
  }

  ST.soundSettings = loadSoundSettings();

  async function refreshMsgMap(force) {
    const now = Date.now();
    if (!force && (now - ST.msgFetchedAt) < MSG_TTL_MS) return;
    try {
      const r = await fetch('/api/v1/alerts/config');
      if (!r.ok) return;
      const d = await r.json();
      const list = Array.isArray(d) ? d : (Array.isArray(d.configs) ? d.configs : (Array.isArray(d.data) ? d.data : (Array.isArray(d.alerts) ? d.alerts : [])));
      const map = {};
      const configMap = {};
      (list || []).forEach(c => {
        const tag = c.tag_name || c.tag;
        if (!tag) return;
        map[String(tag)] = c.message || c.description || '';
        configMap[String(tag)] = c;
      });
      ST.msgMap = map;
      ST.configMap = configMap;
      ST.msgFetchedAt = now;
    } catch (e) { /* yut */ }
  }

  function detectPriority(a) {
    const raw = String(a.priority || a.severity || a.level || a.alarm_priority || '').toLowerCase().trim();
    if (raw === 'critical' || raw === 'crit' || raw === '1' || raw === 'urgent') return { key:'critical', label:'Critical', color:'#dc3545', rank:4 };
    if (raw === 'high' || raw === '2' || raw === 'h' || raw === 'hh') return { key:'high', label:'High', color:'#fd7e14', rank:3 };
    if (raw === 'medium' || raw === 'med' || raw === '3' || raw === 'm') return { key:'medium', label:'Medium', color:'#ffc107', rank:2 };
    if (raw === 'low' || raw === '4' || raw === 'l' || raw === 'll') return { key:'low', label:'Low', color:'#3399ff', rank:1 };
    const g = parseInt(a.alarm_group_id || a.group || 0, 10);
    if (g >= 4) return { key:'critical', label:'Critical', color:'#dc3545', rank:4 };
    if (g === 3) return { key:'high', label:'High', color:'#fd7e14', rank:3 };
    if (g === 2) return { key:'medium', label:'Medium', color:'#ffc107', rank:2 };
    return { key:'low', label:'Low', color:'#3399ff', rank:1 };
  }
  function detectState(a) {
    if (a.state) return String(a.state).toUpperCase();
    const acked = a.acknowledged === true || a.ack === true || a.is_acknowledged === true;
    const cleared = a.cleared === true || a.returned === true || a.is_active === false || a.active === false;
    if (cleared && !acked) return 'RTN';
    if (cleared && acked) return 'NORM';
    if (acked) return 'ACK';
    return 'ALM';
  }
  function detectAlarmLevel(a) {
    if (!a || typeof a !== 'object') return null;
    const levels = {
      LL: { key: 'LL', symbol: '↓↓', label: 'Çok Düşük', color: '#e55353' },
      L: { key: 'L', symbol: '↓', label: 'Düşük', color: '#f9b115' },
      H: { key: 'H', symbol: '↑', label: 'Yüksek', color: '#fd7e14' },
      HH: { key: 'HH', symbol: '↑↑', label: 'Çok Yüksek', color: '#dc3545' },
      BOOL: { key: 'BOOL', symbol: '●', label: 'Dijital Alarm', color: '#3399ff' }
    };
    const normalizeExplicitLevel = raw => {
      const value = String(raw === undefined || raw === null ? '' : raw).trim().toUpperCase().replace(/[\s_-]+/g, '');
      const aliases = { LL: 'LL', LOWLOW: 'LL', VERYLOW: 'LL', L: 'L', LOW: 'L', H: 'H', HIGH: 'H', HH: 'HH', HIGHHIGH: 'HH', VERYHIGH: 'HH' };
      return aliases[value] || null;
    };
    const explicitFields = [
      a.alarm_level, a.alarmLevel, a.threshold_level, a.thresholdLevel,
      a.trigger_level, a.triggerLevel, a.limit_type, a.limitType,
      a.alarm_type, a.alarmType
    ];
    for (const raw of explicitFields) {
      const normalized = normalizeExplicitLevel(raw);
      if (normalized) return levels[normalized];
    }

    const rawValue = a.value;
    if (typeof rawValue === 'boolean' || /^(true|false)$/i.test(String(rawValue === undefined || rawValue === null ? '' : rawValue).trim())) {
      return levels.BOOL;
    }
    if (rawValue !== undefined && rawValue !== null && rawValue !== '') {
      const value = Number(rawValue);
      const config = (a.config && typeof a.config === 'object') ? a.config : (ST.configMap[String(getTag(a))] || null);
      if (Number.isFinite(value) && config) {
        const readLimit = (...keys) => {
          for (const key of keys) {
            if (!Object.prototype.hasOwnProperty.call(config, key) || config[key] === '' || config[key] === null || config[key] === undefined) continue;
            const parsed = Number(config[key]);
            if (Number.isFinite(parsed)) return parsed;
          }
          return null;
        };
        const ll = readLimit('ll_set', 'llSet', 'LLSet');
        const l = readLimit('l_set', 'lSet', 'LSet');
        const h = readLimit('h_set', 'hSet', 'HSet');
        const hh = readLimit('hh_set', 'hhSet', 'HHSet');
        const readEnabled = (level, limit) => {
          const key = `${level}_enabled`;
          if (Object.prototype.hasOwnProperty.call(config, key)) {
            const raw = config[key];
            return raw === true || raw === 1 || /^(true|1|yes|evet)$/i.test(String(raw));
          }
          return limit !== null && limit !== 0;
        };
        const llActive = readEnabled('ll', ll);
        const lActive = readEnabled('l', l);
        const hActive = readEnabled('h', h);
        const hhActive = readEnabled('hh', hh);
        if (llActive && ll !== null && value < ll) return levels.LL;
        if (hhActive && hh !== null && value > hh) return levels.HH;
        if (lActive && l !== null && value < l && (!llActive || ll === null || value > ll)) return levels.L;
        if (hActive && h !== null && value > h && (!hhActive || hh === null || value < hh)) return levels.H;
      }
    }

    const severity = String(a.severity === undefined || a.severity === null ? '' : a.severity).trim().toUpperCase();
    return /^(LL|L|H|HH)$/.test(severity) ? levels[severity] : null;
  }
  const isActive = (a) => { const s = detectState(a); return s !== 'RTN' && s !== 'NORM'; };
  const getMsg = (a) => {
    // Server-side alarm-code catalog resolves device code descriptions here.
    const m = a && (a.display_message || a.alarm_code_description || a.message || a.description || a.text);
    if (m !== undefined && m !== null && String(m).trim() !== '') return String(m);
    const tag = a && (a.tag_name || a.tag || a.point);
    if (tag && ST.msgMap && ST.msgMap[tag]) return String(ST.msgMap[tag]);
    return '';
  };
  const getTag = (a) => a.tag_name || a.tag || a.point || '';
  const getVal = (a) => {
    const v = a.value;
    if (v === undefined || v === null) return '';
    if (typeof v === 'boolean') return v ? 'TRUE' : 'FALSE';
    if (typeof v === 'number') return Number.isInteger(v) ? String(v) : v.toFixed(2);
    return String(v);
  };
  const getTs = (a) => a.start_time || a.started_at || a.timestamp || a.time || a.created_at || a.event_time || null;
  function fmtTime(ts) {
    if (!ts) return '';
    const d = (ts instanceof Date) ? ts : new Date(ts);
    if (isNaN(d.getTime())) return String(ts);
    const pad = n => String(n).padStart(2, '0');
    return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }
  function fmtDateTime(ts) {
    if (!ts) return '';
    const d = (ts instanceof Date) ? ts : new Date(ts);
    if (isNaN(d.getTime())) return String(ts);
    const pad = n => String(n).padStart(2, '0');
    const dateStr = `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
    const timeStr = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    return `<span class="d-block" style="font-size:.75em;color:#9aa0a6;">${dateStr}</span>${timeStr}`;
  }
  function escapeHtml(s){return String(s==null?'':s).replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));}

  function alarmSoundIdentity(a) {
    const explicit = a && (a.alarm_id || a.alarmId || a.id || a.event_id || a.eventId);
    if (explicit !== undefined && explicit !== null && String(explicit) !== '') return `id:${explicit}`;
    return `tag:${getTag(a)}|start:${getTs(a) || ''}`;
  }

  function getUnacknowledgedAlarmKeys(list) {
    return new Set((list || []).filter(a => detectState(a) === 'ALM').map(alarmSoundIdentity));
  }

  function getAlarmSource(a) {
    const tag = getTag(a);
    const config = ST.configMap[String(tag)] || {};
    const parts = [
      a.device_name || a.deviceName || config.device_name || config.deviceName,
      a.area_name || a.areaName || a.zone_name || a.zoneName || config.area_name || config.areaName || config.zone_name || config.zoneName,
      a.form_name || a.formName || a.group_name || a.groupName || config.form_name || config.formName || config.group_name || config.groupName
    ];
    return Array.from(new Set(parts.filter(part => part !== undefined && part !== null && String(part).trim() !== '').map(part => String(part).trim()))).join(' · ');
  }

  function ensureGlobalAlarmToastContainer() {
    let container = document.getElementById('globalAlarmToastContainer');
    if (container) return container;
    container = document.createElement('div');
    container.id = 'globalAlarmToastContainer';
    container.className = 'dr-global-alarm-toast-container';
    container.setAttribute('aria-live', 'assertive');
    container.setAttribute('aria-atomic', 'false');
    document.body.appendChild(container);
    return container;
  }

  function showNewAlarmToast(items) {
    if (!items || !items.length) return;
    const uniqueItems = [];
    const seen = new Set();
    items.forEach(item => {
      const key = alarmSoundIdentity(item);
      if (seen.has(key)) return;
      seen.add(key);
      uniqueItems.push(item);
    });
    if (!uniqueItems.length) return;

    const toast = document.createElement('section');
    toast.className = 'dr-global-alarm-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-label', `${uniqueItems.length} yeni alarm`);

    const header = document.createElement('div');
    header.className = 'dr-global-alarm-toast-header';
    const marker = document.createElement('span');
    marker.className = 'dr-global-alarm-toast-marker';
    marker.textContent = '!';
    const title = document.createElement('strong');
    title.textContent = uniqueItems.length === 1 ? 'Yeni Alarm' : `${uniqueItems.length} Yeni Alarm`;
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'dr-global-alarm-toast-close';
    close.setAttribute('aria-label', 'Bildirimi kapat');
    close.textContent = '×';
    header.append(marker, title, close);
    toast.appendChild(header);

    const body = document.createElement('div');
    body.className = 'dr-global-alarm-toast-body';
    uniqueItems.slice(0, 3).forEach(item => {
      const row = document.createElement('div');
      row.className = 'dr-global-alarm-toast-row';
      const line = document.createElement('div');
      line.className = 'dr-global-alarm-toast-source';
      const tag = document.createElement('code');
      tag.textContent = getTag(item) || 'Bilinmeyen tag';
      line.appendChild(tag);
      const source = getAlarmSource(item);
      if (source) {
        const sourceText = document.createElement('span');
        sourceText.textContent = ` · ${source}`;
        line.appendChild(sourceText);
      }
      const level = detectAlarmLevel(item);
      if (level) {
        const levelBadge = document.createElement('span');
        levelBadge.className = 'dr-global-alarm-toast-level';
        levelBadge.style.backgroundColor = level.color;
        levelBadge.textContent = `${level.symbol} ${level.key}`;
        line.appendChild(levelBadge);
      }
      row.appendChild(line);
      const message = document.createElement('div');
      message.className = 'dr-global-alarm-toast-message';
      message.textContent = getMsg(item) || 'Alarm durumu oluştu.';
      row.appendChild(message);
      body.appendChild(row);
    });
    if (uniqueItems.length > 3) {
      const more = document.createElement('div');
      more.className = 'dr-global-alarm-toast-more';
      more.textContent = `+${uniqueItems.length - 3} alarm daha`;
      body.appendChild(more);
    }
    toast.appendChild(body);
    ensureGlobalAlarmToastContainer().appendChild(toast);

    let dismissed = false;
    const dismiss = () => {
      if (dismissed) return;
      dismissed = true;
      toast.classList.add('dr-global-alarm-toast-hiding');
      setTimeout(() => toast.remove(), 220);
    };
    close.addEventListener('click', dismiss);
    setTimeout(dismiss, 5000);
  }

  function setSoundStatus(message, tone) {
    const el = document.getElementById('globalAlarmSoundStatus');
    if (!el) return;
    el.textContent = message;
    el.className = `small mt-2 text-${tone || 'white-50'}`;
  }

  function ensureAudioContext() {
    if (ST.sound.context) return ST.sound.context;
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) {
      setSoundStatus('Bu tarayıcı Web Audio desteği sunmuyor.', 'danger');
      return null;
    }
    try { ST.sound.context = new AudioContextClass(); }
    catch (e) { setSoundStatus('Ses aygıtı başlatılamadı.', 'danger'); }
    return ST.sound.context;
  }

  function playAlarmBeep() {
    const context = ensureAudioContext();
    if (!context) return;
    const emit = () => {
      if (context.state !== 'running') {
        setSoundStatus('Tarayıcı ses izni bekliyor; “Sesi Test Et” düğmesine basın.', 'warning');
        return;
      }
      const now = context.currentTime;
      const patterns = {
        standard: [
          { frequency: 740, start: 0, duration: 0.24, wave: 'sine', gain: 1 }
        ],
        double: [
          { frequency: 880, start: 0, duration: 0.16, wave: 'square', gain: 0.72 },
          { frequency: 880, start: 0.30, duration: 0.16, wave: 'square', gain: 0.72 }
        ],
        ascending: [
          { frequency: 620, start: 0, duration: 0.20, wave: 'sine', gain: 0.9 },
          { frequency: 820, start: 0.24, duration: 0.24, wave: 'sine', gain: 0.9 }
        ],
        siren: [
          { frequency: 560, endFrequency: 960, start: 0, duration: 0.72, wave: 'sawtooth', gain: 0.55 }
        ]
      };
      const pattern = patterns[ST.soundSettings.soundType] || patterns.standard;
      pattern.forEach(note => {
        const startsAt = now + note.start;
        const endsAt = startsAt + note.duration;
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.type = note.wave;
        oscillator.frequency.setValueAtTime(note.frequency, startsAt);
        if (note.endFrequency) {
          oscillator.frequency.linearRampToValueAtTime(note.endFrequency, startsAt + note.duration / 2);
          oscillator.frequency.linearRampToValueAtTime(note.frequency, endsAt);
        }
        gain.gain.setValueAtTime(0.0001, startsAt);
        gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, ST.soundSettings.volume * note.gain), startsAt + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, endsAt);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.start(startsAt);
        oscillator.stop(endsAt + 0.02);
      });
    };
    if (context.state === 'suspended') {
      Promise.resolve(context.resume()).then(emit).catch(() => setSoundStatus('Tarayıcı ses izni vermedi; “Sesi Test Et” düğmesine basın.', 'warning'));
    } else {
      emit();
    }
  }

  function stopAlarmSound(silenceCurrent) {
    if (ST.sound.loopTimer) clearInterval(ST.sound.loopTimer);
    if (ST.sound.stopTimer) clearTimeout(ST.sound.stopTimer);
    ST.sound.loopTimer = null;
    ST.sound.stopTimer = null;
    ST.sound.playing = false;
    if (silenceCurrent) ST.sound.currentKeys.forEach(key => ST.sound.silencedKeys.add(key));
    updateSoundUi();
  }

  function startAlarmSound(restartDuration) {
    if (!ST.soundSettings.enabled || !ST.sound.currentKeys.size) return;
    if (ST.sound.playing && !restartDuration) return;
    if (ST.sound.stopTimer) clearTimeout(ST.sound.stopTimer);
    ST.sound.stopTimer = null;
    if (!ST.sound.loopTimer) {
      ST.sound.playing = true;
      playAlarmBeep();
      ST.sound.loopTimer = setInterval(playAlarmBeep, 1400);
    }
    if (ST.soundSettings.mode === 'duration') {
      ST.sound.stopTimer = setTimeout(() => stopAlarmSound(true), ST.soundSettings.durationSeconds * 1000);
    }
    updateSoundUi();
  }

  function processAlarmSound(list, forceCurrent) {
    const currentKeys = getUnacknowledgedAlarmKeys(list);
    const newAlarmItems = !forceCurrent && ST.alarmSnapshotReady
      ? (list || []).filter(a => detectState(a) === 'ALM' && !ST.sound.previousKeys.has(alarmSoundIdentity(a)))
      : [];
    if (!forceCurrent) ST.alarmSnapshotReady = true;
    ST.sound.silencedKeys.forEach(key => { if (!currentKeys.has(key)) ST.sound.silencedKeys.delete(key); });
    const newKeys = new Set();
    currentKeys.forEach(key => {
      if ((forceCurrent || !ST.sound.previousKeys.has(key)) && !ST.sound.silencedKeys.has(key)) newKeys.add(key);
    });
    ST.sound.currentKeys = currentKeys;
    ST.sound.previousKeys = new Set(currentKeys);
    showNewAlarmToast(newAlarmItems);

    if (!ST.soundSettings.enabled) {
      stopAlarmSound(false);
      return;
    }
    const audibleCount = Array.from(currentKeys).filter(key => !ST.sound.silencedKeys.has(key)).length;
    if (ST.soundSettings.mode === 'until-ack') {
      if (audibleCount) startAlarmSound(false);
      else stopAlarmSound(false);
    } else if (newKeys.size) {
      startAlarmSound(true);
    }
    updateSoundUi();
  }

  function silenceCurrentAlarmSound() {
    stopAlarmSound(true);
    setSoundStatus('Mevcut alarmların sesi bu kullanıcı için susturuldu. Yeni bir alarm yeniden ses verir.', 'success');
  }

  function updateSoundUi() {
    const settings = ST.soundSettings || SOUND_DEFAULTS;
    const enabled = document.getElementById('globalAlarmSoundEnabled');
    const mode = document.getElementById('globalAlarmSoundMode');
    const soundType = document.getElementById('globalAlarmSoundType');
    const duration = document.getElementById('globalAlarmSoundDuration');
    const volume = document.getElementById('globalAlarmSoundVolume');
    const button = document.getElementById('globalAlarmSoundSettingsBtn');
    const silence = document.getElementById('globalAlarmSilenceBtn');
    const attention = document.getElementById('globalAlarmAttention');
    const bellButton = document.getElementById('hubBellBtn');
    if (enabled) enabled.checked = settings.enabled;
    if (mode) mode.value = settings.mode;
    if (soundType) soundType.value = settings.soundType;
    if (duration) {
      duration.value = String(settings.durationSeconds);
      duration.disabled = settings.mode === 'until-ack';
    }
    if (volume) volume.value = String(settings.volume);
    if (button) {
      button.classList.toggle('btn-success', settings.enabled);
      button.classList.toggle('btn-outline-light', !settings.enabled);
      button.title = settings.enabled ? 'Alarm sesi açık — ayarları değiştir' : 'Alarm sesi kapalı — ayarları aç';
    }
    if (silence) silence.style.display = settings.enabled && ST.sound.currentKeys.size ? '' : 'none';
    if (attention) {
      attention.style.display = ST.sound.playing ? 'inline-flex' : 'none';
    }
    if (bellButton) {
      const bellLabel = ST.sound.playing ? 'Alarm sesi çalıyor — alarm kaynağını aç' : 'Aktif Alarmlar';
      bellButton.title = bellLabel;
      bellButton.setAttribute('aria-label', bellLabel);
    }
    if (!document.getElementById('globalAlarmSoundStatus')) return;
    if (!settings.enabled) setSoundStatus('Kapalı. Ayar yalnızca bu tarayıcıdaki bu kullanıcı için saklanır.', 'white-50');
    else if (ST.sound.playing) setSoundStatus(`${SOUND_TYPE_LABELS[settings.soundType]} çalıyor.`, 'warning');
    else if (settings.mode === 'until-ack') setSoundStatus(`Açık: ${SOUND_TYPE_LABELS[settings.soundType]}, kaynak ACK verene veya yerel olarak susturulana kadar.`, 'success');
    else setSoundStatus(`Açık: ${SOUND_TYPE_LABELS[settings.soundType]}, yeni alarmda ${settings.durationSeconds} saniye ses verir.`, 'success');
  }

  function ensureModal() {
    if (ST.modalEl) return ST.modalEl;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = `
      <div class="modal fade" id="globalActiveAlarmsModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content" style="background-color:#242736; color:#e4e6eb;">
            <div class="modal-header" style="border-bottom:1px solid #2f3349;">
              <h5 class="modal-title"><i class="fas fa-bell text-danger me-2"></i>Alarmlar
                <span id="globalActiveAlarmsCount" class="badge bg-danger ms-2">0</span>
              </h5>
              <ul class="nav nav-pills ms-3" role="tablist" id="globalAlarmsTabs">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="gAlarmsActiveTab" data-coreui-toggle="pill" data-coreui-target="#gAlarmsActivePane" type="button" role="tab">
                    <i class="fas fa-bell-on me-1"></i>Aktif
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="gAlarmsHistoryTab" data-coreui-toggle="pill" data-coreui-target="#gAlarmsHistoryPane" type="button" role="tab">
                    <i class="fas fa-history me-1"></i>Geçmiş
                  </button>
                </li>
              </ul>
              <div class="ms-auto me-2">
                <button class="btn btn-sm btn-outline-light me-1" id="globalAlarmSoundSettingsBtn" type="button" title="Alarm sesi ayarları" aria-expanded="false"><i class="fas fa-volume-up me-1"></i>Ses Ayarları</button>
                <button class="btn btn-sm btn-warning me-1" id="globalAlarmSilenceBtn" type="button" style="display:none;" title="Yalnızca bu kullanıcı ve bu PC'deki mevcut alarm sesini sustur"><i class="fas fa-volume-mute me-1"></i>Sesi Sustur</button>
                <button class="btn btn-sm btn-outline-light" onclick="window.__drGlobalAlarms && window.__drGlobalAlarms.refresh()" title="Yenile"><i class="fas fa-sync-alt"></i></button>
              </div>
              <button type="button" class="btn-close btn-close-white" data-coreui-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div id="globalAlarmSoundSettingsPanel" class="border border-secondary rounded p-3 mb-3" style="display:none;background:#1a1d2e;">
                <div class="d-flex flex-wrap align-items-center gap-3">
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" id="globalAlarmSoundEnabled">
                    <label class="form-check-label" for="globalAlarmSoundEnabled">Bu PC ve kullanıcı için alarm sesi</label>
                  </div>
                  <div>
                    <label class="form-label small text-white-50 mb-1" for="globalAlarmSoundMode">Çalma biçimi</label>
                    <select class="form-select form-select-sm bg-dark text-white border-secondary" id="globalAlarmSoundMode">
                      <option value="duration">Belirlenen süre boyunca</option>
                      <option value="until-ack">ACK veya yerel susturmaya kadar</option>
                    </select>
                  </div>
                  <div>
                    <label class="form-label small text-white-50 mb-1" for="globalAlarmSoundType">Alarm sesi</label>
                    <select class="form-select form-select-sm bg-dark text-white border-secondary" id="globalAlarmSoundType">
                      <option value="standard">Standart Darbe</option>
                      <option value="double">Çift Uyarı</option>
                      <option value="ascending">Yükselen Ton</option>
                      <option value="siren">Siren</option>
                    </select>
                  </div>
                  <div>
                    <label class="form-label small text-white-50 mb-1" for="globalAlarmSoundDuration">Süre</label>
                    <select class="form-select form-select-sm bg-dark text-white border-secondary" id="globalAlarmSoundDuration">
                      <option value="5">5 saniye</option>
                      <option value="10">10 saniye</option>
                      <option value="15">15 saniye</option>
                      <option value="30">30 saniye</option>
                      <option value="60">60 saniye</option>
                    </select>
                  </div>
                  <div style="min-width:150px;">
                    <label class="form-label small text-white-50 mb-1" for="globalAlarmSoundVolume">Ses seviyesi</label>
                    <input class="form-range" type="range" id="globalAlarmSoundVolume" min="0.05" max="0.8" step="0.05">
                  </div>
                  <button class="btn btn-sm btn-outline-info ms-auto" type="button" id="globalAlarmSoundTestBtn"><i class="fas fa-play me-1"></i>Sesi Test Et</button>
                </div>
                <div id="globalAlarmSoundStatus" class="small mt-2 text-white-50" aria-live="polite"></div>
                <div class="small text-white-50 mt-1"><i class="fas fa-info-circle me-1"></i>Varsayılan kapalıdır. Ayar sunucuya gönderilmez; yalnızca bu tarayıcıdaki oturum kullanıcısına kaydedilir. “Sesi Sustur” mevcut alarmları yerel olarak susturur, yeni alarm tekrar ses verir.</div>
              </div>
              <div class="tab-content">
                <!-- AKTİF -->
                <div class="tab-pane fade show active" id="gAlarmsActivePane" role="tabpanel">
                  <div class="table-responsive" style="max-height:65vh;">
                    <table class="table table-sm table-dark table-hover align-middle small mb-0">
                      <thead class="sticky-top">
                        <tr style="background:#262940;">
                          <th>Zaman</th>
                          <th>Öncelik</th>
                          <th>Tag</th>
                          <th>Açıklama (Message)</th>
                          <th>Değer</th>
                          <th>Durum / Seviye</th>
                        </tr>
                      </thead>
                      <tbody id="globalActiveAlarmsBody">
                        <tr><td colspan="6" class="text-center text-white-50 py-4">Yükleniyor...</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- GEÇMİŞ -->
                <div class="tab-pane fade" id="gAlarmsHistoryPane" role="tabpanel">
                  <div class="d-flex flex-wrap gap-2 mb-2 align-items-end">
                    <div>
                      <label class="form-label small text-white-50 mb-1">Tag (opsiyonel)</label>
                      <input id="gAlarmsHistTag" type="text" class="form-control form-control-sm bg-dark text-white border-secondary" placeholder="TAG_X">
                    </div>
                    <div>
                      <label class="form-label small text-white-50 mb-1">Başlangıç (≥)</label>
                      <input id="gAlarmsHistFrom" type="datetime-local" class="form-control form-control-sm bg-dark text-white border-secondary">
                    </div>
                    <div>
                      <label class="form-label small text-white-50 mb-1">Bitiş (≤)</label>
                      <input id="gAlarmsHistTo" type="datetime-local" class="form-control form-control-sm bg-dark text-white border-secondary">
                    </div>
                    <div class="form-check ms-2">
                      <input class="form-check-input" type="checkbox" id="gAlarmsHistOnlyClosed">
                      <label class="form-check-label small text-white-50" for="gAlarmsHistOnlyClosed">Sadece kapanmış</label>
                    </div>
                    <div class="ms-auto">
                      <button class="btn btn-sm btn-primary" id="gAlarmsHistApply"><i class="fas fa-search me-1"></i>Uygula</button>
                    </div>
                  </div>
                  <div class="table-responsive" style="max-height:60vh;">
                    <table class="table table-sm table-dark table-hover align-middle small mb-0">
                      <thead class="sticky-top">
                        <tr style="background:#262940;">
                          <th>Başlangıç</th>
                          <th>Bitiş</th>
                          <th>Süre</th>
                          <th>Severity</th>
                          <th>Tag</th>
                          <th>Mesaj</th>
                          <th>Başlangıç Değ.</th>
                          <th>Bitiş Değ.</th>
                        </tr>
                      </thead>
                      <tbody id="gAlarmsHistoryBody">
                        <tr><td colspan="8" class="text-center text-white-50 py-4">"Uygula" ile listeleyin.</td></tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mt-2">
                    <small class="text-white-50" id="gAlarmsHistInfo">—</small>
                    <div class="btn-group btn-group-sm">
                      <button class="btn btn-outline-light" id="gAlarmsHistPrev"><i class="fas fa-chevron-left"></i></button>
                      <button class="btn btn-outline-light" id="gAlarmsHistNext"><i class="fas fa-chevron-right"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="border-top:1px solid #2f3349;">
              <small class="text-white-50 me-auto">Kaynak: <code>/api/v1/alerts/active</code> & <code>/alerts/history</code></small>
              <button type="button" class="btn btn-secondary btn-sm" data-coreui-dismiss="modal">Kapat</button>
            </div>
          </div>
        </div>
      </div>`;
    document.body.appendChild(wrapper.firstElementChild);
    ST.modalEl = document.getElementById('globalActiveAlarmsModal');

    const soundSettingsBtn = document.getElementById('globalAlarmSoundSettingsBtn');
    const soundSettingsPanel = document.getElementById('globalAlarmSoundSettingsPanel');
    const soundEnabled = document.getElementById('globalAlarmSoundEnabled');
    const soundMode = document.getElementById('globalAlarmSoundMode');
    const soundType = document.getElementById('globalAlarmSoundType');
    const soundDuration = document.getElementById('globalAlarmSoundDuration');
    const soundVolume = document.getElementById('globalAlarmSoundVolume');
    const soundTest = document.getElementById('globalAlarmSoundTestBtn');
    const silenceButton = document.getElementById('globalAlarmSilenceBtn');
    if (soundSettingsBtn && soundSettingsPanel) {
      soundSettingsBtn.addEventListener('click', () => {
        const willOpen = soundSettingsPanel.style.display === 'none';
        soundSettingsPanel.style.display = willOpen ? '' : 'none';
        soundSettingsBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        updateSoundUi();
      });
    }
    if (soundEnabled) soundEnabled.addEventListener('change', () => saveSoundSettings({ ...ST.soundSettings, enabled: soundEnabled.checked }));
    if (soundMode) soundMode.addEventListener('change', () => saveSoundSettings({ ...ST.soundSettings, mode: soundMode.value }));
    if (soundType) soundType.addEventListener('change', () => saveSoundSettings({ ...ST.soundSettings, soundType: soundType.value }));
    if (soundDuration) soundDuration.addEventListener('change', () => saveSoundSettings({ ...ST.soundSettings, durationSeconds: Number(soundDuration.value) }));
    if (soundVolume) soundVolume.addEventListener('change', () => saveSoundSettings({ ...ST.soundSettings, volume: Number(soundVolume.value) }));
    if (soundTest) soundTest.addEventListener('click', () => {
      playAlarmBeep();
      setSoundStatus('Test sinyali gönderildi.', 'info');
    });
    if (silenceButton) silenceButton.addEventListener('click', silenceCurrentAlarmSound);
    updateSoundUi();

    // History tab event'leri
    const histTabBtn = document.getElementById('gAlarmsHistoryTab');
    if (histTabBtn) {
      histTabBtn.addEventListener('shown.coreui.tab', () => loadHistory());
      histTabBtn.addEventListener('shown.bs.tab', () => loadHistory());
    }
    const applyBtn = document.getElementById('gAlarmsHistApply');
    if (applyBtn) applyBtn.addEventListener('click', () => { ST.histOffset = 0; loadHistory(); });
    const prevBtn = document.getElementById('gAlarmsHistPrev');
    if (prevBtn) prevBtn.addEventListener('click', () => {
      ST.histOffset = Math.max(0, (ST.histOffset || 0) - (ST.histLimit || 100));
      loadHistory();
    });
    const nextBtn = document.getElementById('gAlarmsHistNext');
    if (nextBtn) nextBtn.addEventListener('click', () => {
      const next = (ST.histOffset || 0) + (ST.histLimit || 100);
      if (ST.histHasMore) { ST.histOffset = next; loadHistory(); }
    });

    return ST.modalEl;
  }

  // Geçmiş alarmlar
  async function loadHistory() {
    const tbody = document.getElementById('gAlarmsHistoryBody');
    const info = document.getElementById('gAlarmsHistInfo');
    if (!tbody) return;
    tbody.innerHTML = '<tr><td colspan="8" class="text-center text-white-50 py-3">Yükleniyor...</td></tr>';

    const limit = ST.histLimit || 100;
    const offset = ST.histOffset || 0;
    const tag = (document.getElementById('gAlarmsHistTag') || {}).value || '';
    const from = (document.getElementById('gAlarmsHistFrom') || {}).value || '';
    const to = (document.getElementById('gAlarmsHistTo') || {}).value || '';
    const onlyClosed = !!(document.getElementById('gAlarmsHistOnlyClosed') || {}).checked;

    const qs = new URLSearchParams();
    qs.set('limit', String(limit));
    qs.set('offset', String(offset));
    if (tag) qs.set('tag_name', tag);
    if (from) qs.set('start_from', new Date(from).toISOString());
    if (to) qs.set('start_to', new Date(to).toISOString());
    if (onlyClosed) qs.set('only_closed', 'true');

    try {
      const res = await fetch(`/api/v1/alerts/history?${qs.toString()}`);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      const list = data.history || [];
      const totalValue = data.total === null || data.total === undefined ? null : Number(data.total);
      ST.histTotal = Number.isFinite(totalValue) ? totalValue : null;
      ST.histLimit = data.limit || limit;
      ST.histOffset = data.offset || offset;
      ST.histHasMore = typeof data.has_more === 'boolean'
        ? data.has_more
        : (ST.histTotal !== null && ST.histOffset + list.length < ST.histTotal);

      if (info) {
        const totalText = ST.histTotal === null ? 'hesaplanıyor' : String(ST.histTotal);
        info.textContent = `Yetkili toplam: ${totalText} • Gösterilen: ${list.length} • offset: ${ST.histOffset}`;
      }
      const previousButton = document.getElementById('gAlarmsHistPrev');
      const nextButton = document.getElementById('gAlarmsHistNext');
      if (previousButton) previousButton.disabled = ST.histOffset <= 0;
      if (nextButton) nextButton.disabled = !ST.histHasMore;

      if (!list.length) {
        tbody.innerHTML = '<tr><td colspan="8" class="text-center text-white-50 py-3">Kayıt yok.</td></tr>';
        return;
      }
      tbody.innerHTML = list.map(h => {
        const start = h.start_time ? new Date(h.start_time) : null;
        const end = h.end_time ? new Date(h.end_time) : null;
        const dur = (start && end) ? humanDuration((end - start) / 1000) : (start ? 'devam ediyor' : '—');
        const sev = h.severity || '-';
        const sevColor = sev === 'HH' || sev === 'CRITICAL' ? '#dc3545' :
                        sev === 'H' ? '#fd7e14' :
                        sev === 'L' || sev === 'LL' ? '#ffc107' :
                        sev === 'WARN' ? '#0dcaf0' : '#6c757d';
        return `
          <tr>
            <td><code class="text-white-50">${start ? fmtDateTime(start.toISOString()) : '-'}</code></td>
            <td><code class="text-white-50">${end ? fmtDateTime(end.toISOString()) : '<span class="text-warning">—</span>'}</code></td>
            <td>${escapeHtml(dur)}</td>
            <td><span class="badge" style="background:${sevColor};">${escapeHtml(sev)}</span></td>
            <td><code class="text-info">${escapeHtml(h.tag_name || '-')}</code></td>
            <td>${escapeHtml(h.display_message || h.alarm_code_description || h.message || h.description || '-')}</td>
            <td><code>${escapeHtml(h.value ?? '-')}</code></td>
            <td><code>${escapeHtml(h.end_value ?? '-')}</code></td>
          </tr>`;
      }).join('');
    } catch (e) {
      tbody.innerHTML = `<tr><td colspan="8" class="text-center text-danger py-3">Hata: ${escapeHtml(e.message)}</td></tr>`;
    }
  }

  function humanDuration(sec) {
    sec = Math.max(0, Math.round(sec));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    if (h) return `${h}s ${m}d`;
    if (m) return `${m}d ${s}sn`;
    return `${s}sn`;
  }

  function renderModal() {
    const tbody = document.getElementById('globalActiveAlarmsBody');
    const cnt = document.getElementById('globalActiveAlarmsCount');
    if (!tbody) return;
    const list = (ST.alerts || []).filter(isActive);
    if (cnt) cnt.textContent = String(list.length);
    if (!list.length) {
      tbody.innerHTML = '<tr><td colspan="6" class="text-center text-success py-4"><i class="fas fa-check-circle"></i> Aktif alarm yok</td></tr>';
      return;
    }
    tbody.innerHTML = list.map(a => {
      const p = detectPriority(a);
      const state = detectState(a);
      const alarmLevel = detectAlarmLevel(a);
      const stateColor = state === 'ALM' ? '#dc3545' : state === 'ACK' ? '#f9b115' : '#28a745';
      const msg = getMsg(a);
      const alarmLevelHtml = alarmLevel
        ? `<span class="badge ms-2" title="${escapeHtml(`${alarmLevel.key} — ${alarmLevel.label}`)}" style="background:${alarmLevel.color};">${escapeHtml(`${alarmLevel.symbol} ${alarmLevel.key}`)}</span><small class="d-block text-white-50 mt-1">${escapeHtml(alarmLevel.label)}</small>`
        : '<small class="d-block text-white-50 mt-1">Seviye bilinmiyor</small>';
      return `
        <tr>
          <td><code class="text-white-50">${escapeHtml(fmtTime(getTs(a)))}</code></td>
          <td><span class="badge" style="background:${p.color};">${p.label}</span></td>
          <td><code class="text-info">${escapeHtml(getTag(a))}</code></td>
          <td>${msg ? escapeHtml(msg) : '<span class="text-white-50">—</span>'}</td>
          <td><code>${escapeHtml(getVal(a))}</code></td>
          <td><strong style="color:${stateColor};">${escapeHtml(state)}</strong>${alarmLevelHtml}</td>
        </tr>`;
    }).join('');
  }

  function updateBadge() {
    const badge = document.getElementById('globalAlarmBadge');
    if (!badge) return;
    const list = (ST.alerts || []).filter(isActive);
    if (!list.length) {
      badge.style.display = 'none';
      badge.classList.remove('dr-bell-blink');
      return;
    }
    badge.style.display = '';
    badge.textContent = list.length > 99 ? '99+' : String(list.length);
    // Critical varsa yanıp sönsün
    const hasCrit = list.some(a => detectPriority(a).key === 'critical');
    badge.classList.toggle('dr-bell-blink', hasCrit);
    badge.style.background = hasCrit ? '#dc3545' : '#fd7e14';
  }

  // CSS
  if (!document.getElementById('drBellBlinkCss')) {
    const css = document.createElement('style');
    css.id = 'drBellBlinkCss';
    css.textContent = `
      @keyframes drBellBlink { 0%,49%{opacity:1} 50%,100%{opacity:0.35} }
      .dr-bell-blink { animation: drBellBlink 1s linear infinite; }
      @keyframes drAlarmAttentionBlink { 0%,44%{opacity:1;transform:scale(1)} 50%,100%{opacity:.2;transform:scale(.82)} }
      .dr-alarm-attention { position:absolute; top:-9px; left:-11px; width:18px; height:18px; align-items:center; justify-content:center; border-radius:50%; background:#dc3545; color:#fff; border:2px solid var(--cui-body-bg, #fff); font:bold 12px/1 Arial,sans-serif; box-shadow:0 0 0 2px rgba(220,53,69,.2); animation:drAlarmAttentionBlink .8s linear infinite; pointer-events:none; z-index:2; }
      .dr-global-alarm-toast-container { position:fixed; top:1rem; right:1rem; z-index:1095; width:min(420px,calc(100vw - 2rem)); display:flex; flex-direction:column; gap:.75rem; pointer-events:none; }
      .dr-global-alarm-toast { overflow:hidden; color:#f8f9fa; background:#242736; border:1px solid #dc3545; border-left:5px solid #dc3545; border-radius:.5rem; box-shadow:0 .5rem 1.25rem rgba(0,0,0,.35); pointer-events:auto; animation:drAlarmToastIn .2s ease-out; transition:opacity .2s ease,transform .2s ease; }
      .dr-global-alarm-toast-hiding { opacity:0; transform:translateX(1rem); }
      .dr-global-alarm-toast-header { display:flex; align-items:center; gap:.5rem; padding:.65rem .75rem; border-bottom:1px solid #3b4055; }
      .dr-global-alarm-toast-marker { width:20px; height:20px; display:inline-flex; align-items:center; justify-content:center; flex:0 0 auto; border-radius:50%; background:#dc3545; color:#fff; font-weight:800; }
      .dr-global-alarm-toast-close { margin-left:auto; padding:0 .15rem; border:0; background:transparent; color:#c8cbd3; font-size:1.35rem; line-height:1; cursor:pointer; }
      .dr-global-alarm-toast-close:hover { color:#fff; }
      .dr-global-alarm-toast-body { padding:.15rem .75rem .7rem; }
      .dr-global-alarm-toast-row { padding:.55rem 0 .35rem; }
      .dr-global-alarm-toast-row + .dr-global-alarm-toast-row { border-top:1px solid #3b4055; }
      .dr-global-alarm-toast-source { display:flex; align-items:center; flex-wrap:wrap; gap:.2rem; color:#e4e6eb; font-size:.82rem; }
      .dr-global-alarm-toast-source code { color:#69c0ff; font-weight:700; }
      .dr-global-alarm-toast-level { margin-left:auto; padding:.15rem .4rem; border-radius:.25rem; color:#fff; font-size:.7rem; font-weight:700; }
      .dr-global-alarm-toast-message { margin-top:.2rem; color:#f8f9fa; font-size:.9rem; }
      .dr-global-alarm-toast-more { padding-top:.45rem; border-top:1px solid #3b4055; color:#adb5bd; font-size:.8rem; text-align:right; }
      @keyframes drAlarmToastIn { from{opacity:0;transform:translateX(1rem)} to{opacity:1;transform:translateX(0)} }
      @media (prefers-reduced-motion: reduce) { .dr-alarm-attention,.dr-global-alarm-toast { animation:none; } .dr-global-alarm-toast { transition:none; } }
    `;
    document.head.appendChild(css);
  }

  async function refresh() {
    try {
      await refreshMsgMap(false);
      const res = await fetch('/api/v1/alerts/active');
      if (!res.ok) return;
      const data = await res.json();
      const list = Array.isArray(data) ? data : (Array.isArray(data.alerts) ? data.alerts : (Array.isArray(data.data) ? data.data : (Array.isArray(data.active) ? data.active : [])));
      ST.alerts = list || [];
      processAlarmSound(ST.alerts, false);
      updateBadge();
      // Modal açıksa içeriği güncelle
      if (ST.modalEl && ST.modalEl.classList.contains('show')) renderModal();
    } catch (e) { /* sessizce yut */ }
  }
  ST.refresh = refresh;
  ST.silence = silenceCurrentAlarmSound;

  window.addEventListener('storage', event => {
    if (event.key !== getSoundStorageKey()) return;
    ST.soundSettings = loadSoundSettings();
    if (!ST.soundSettings.enabled) stopAlarmSound(false);
    else processAlarmSound(ST.alerts, true);
    updateSoundUi();
  });

  window.openActiveAlarmsModal = function () {
    ensureModal();
    renderModal();
    if (window.coreui && coreui.Modal) {
      coreui.Modal.getOrCreateInstance(ST.modalEl).show();
    } else {
      ST.modalEl.style.display = 'block';
    }
    refreshMsgMap(true).then(() => { renderModal(); refresh(); });
  };

  // Bell butonu DOM'a girene kadar kısa polling, sonra döngü başlat
  function start() {
    refresh();
    if (ST.timer) clearInterval(ST.timer);
    ST.timer = setInterval(refresh, REFRESH_MS);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
// ─── /GLOBAL ACTIVE ALARMS ─────────────────────────────────
